import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ApiService } from '../../../../../shared/services/api.service';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../shared/services/common.service';
import { AutofillmsmeService } from '../../../../../shared/services/autofillmsme.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { catchError, finalize, of } from 'rxjs';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';


@Component({
  selector: 'app-msmeuserverification',
  templateUrl: './msmeuserverification.component.html',
  styleUrls: ['./msmeuserverification.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
})
export class MSMEUSERVERIFICATIONComponent {
  private _formBuilder = inject(FormBuilder);
  data: any[];
  isDirty = false; // Set to true when user changes something
  loadingSequence: boolean = false;

  firstFormGroup = this._formBuilder.group({
    udyamRegistrationNumber: ['',     
      Validators.compose([
        Validators.required,
        Validators.pattern(this.commonService.udyamNumber)
      ]),
    ],
    ownersMobileNumber: [
      '',
      Validators.compose([
        Validators.required,
        Validators.pattern(this.commonService.mobilePattern)
      ])
    ],
  });

  ngOnInit() {
    sessionStorage.clear();
    this.firstFormGroup
      .get('udyamRegistrationNumber')
      ?.valueChanges.subscribe((value: string | null) => {
        if (value && value.startsWith('UDYAM-MH-')) {
          const prefix = 'UDYAM-MH-';
          // Remove any non-numeric characters after the prefix
          let formattedValue = value.slice(prefix.length).replace(/[^0-9]/g, '');
          // Add a hyphen after the first two digits if needed
          if (formattedValue.length > 2) {
            formattedValue = `${formattedValue.slice(0, 2)}-${formattedValue.slice(2)}`;
          }
          // Update the field value with the formatted value
          this.firstFormGroup
            .get('udyamRegistrationNumber')
            ?.setValue(prefix + formattedValue, { emitEvent: false });
        } else if (value === null || value === '') {
          // Reset the value to the default prefix if empty or null
          this.firstFormGroup
            .get('udyamRegistrationNumber')
            ?.setValue('', { emitEvent: false });
        }
      });
  }

  
  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private msme_serv: AutofillmsmeService,
    private ngxUiLoaderService: NgxUiLoaderService,) {
    this.data = [];

    this.firstFormGroup.valueChanges.subscribe(() => {
      this.isDirty = true;
    });
  }

  get f() {
    return this.firstFormGroup.controls;
  }

  //This method is used with Udyam API Integration
  verifyUser() {
    if (this.firstFormGroup.invalid) {
      this.toastrService.error("Invalid form. Please fill out all required fields correctly.");
      return;
    }

    const u_num = this.firstFormGroup.controls.udyamRegistrationNumber.value;
    const mob = this.firstFormGroup.controls.ownersMobileNumber.value;

    if (u_num && mob) {
      const formDatavalue = {
        udyamRegistrationNumber: this.firstFormGroup.controls.udyamRegistrationNumber.value,
        ownersMobileNumber: this.firstFormGroup.controls.ownersMobileNumber.value
      }

      const dtoUdyam = {
        authToken: "",
        clientId: "",
        udyamNo: this.firstFormGroup.controls.udyamRegistrationNumber.value,
         mobile: this.firstFormGroup.controls.ownersMobileNumber.value
          //mobile: "8976557045"
      }

      this.loadingSequence = true;
      this.apiService.postRequest(API_ENDPOINTS.MSME.VALIDATEUSER, formDatavalue,true).subscribe(
        res => {
          if (res.status) {
            sessionStorage.setItem("udyamRegistrationNumber", u_num || '');
            sessionStorage.setItem("ownersMobileNumber", mob || '');
            this.apiService.postRequest(API_ENDPOINTS.UDYAM.VERIFYUDYAM, dtoUdyam).subscribe(
              response => {
                if (response.isResponse === 'Y') {
                  sessionStorage.setItem("isUdyamVerified", 'true');
                  sessionStorage.setItem("email", response.data.email.trim());
                  sessionStorage.setItem('msmeuserVerificationCompleted', 'true');
                  this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
                } else if ((response.isResponse === 'E1') || (response.isResponse === 'E3')) {
                  this.toastrService.error(response.msg);
                  this.loadingSequence = false;
                  //let userResponse: boolean = confirm(response.msg + " : No matching record found from Udyam Portal. Register as a new User?");
                  //if (userResponse) {
                  //  sessionStorage.setItem("isUdyamVerified", 'false');
                  //  this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
                  //}
                } else if (response.isResponse === 'E2') { //When E2= Technical Error
                  this.toastrService.error(response.msg);
                  this.loadingSequence = false;
                  //let userResponse: boolean = confirm("A technical issue occurred while fetching the record from the Udyam Portal. Would you like to register as a new user?");
                  //if (userResponse) {
                  //  sessionStorage.setItem("isUdyamVerified", 'false');
                  //  this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
                  //}
                  // above code is commented as per suggested by Swapnali Mam and Mr. Harshal-BA- on 24th Feb 2025, as Dept want to block manual entry for
                  // registration process....
                }
              }
            );           
              finalize(() => {
                this.loadingSequence = false;  // Stop the loader after both calls complete (success or error)
              })
          }
        }
      );      
    } else {
      this.toastrService.error("Please provide both Udyam Registration Number and Mobile Number.");
    }
  } 


  //This method is used for AutoFill.Json file
  //verifyUser() {
  //  if (this.firstFormGroup.invalid) {
  //    this.toastrService.error("Invalid form. Please fill out all required fields correctly.");
  //    return;
  //  }

  //  const u_num = this.firstFormGroup.controls.udyamRegistrationNumber.value;
  //  const mob = this.firstFormGroup.controls.ownersMobileNumber.value;

  //  if (u_num && mob) {
  //    const formDatavalue = {
  //      udyamRegistrationNumber: this.firstFormGroup.controls.udyamRegistrationNumber.value,
  //      ownersMobileNumber: this.firstFormGroup.controls.ownersMobileNumber.value
  //    }
  //    this.msme_serv.verifyUdyamAndMobile(u_num, mob).then(result => {
  //      if (result) {
  //        this.toastrService.success("Record verified from Udyam Portal successfully!");
  //        this.apiService.postRequest(API_ENDPOINTS.MSME.VALIDATEUSER, formDatavalue).subscribe(
  //          res => {
  //            if (res.status) {
  //              sessionStorage.setItem("udyamRegistrationNumber", u_num || '');
  //              sessionStorage.setItem("ownersMobileNumber", mob || '');
  //              sessionStorage.setItem("isUdyamVerified", 'true');
  //              this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
  //            }
  //          }
  //        );
  //      } else {
  //        this.apiService.postRequest(API_ENDPOINTS.MSME.VALIDATEUSER, formDatavalue).subscribe(
  //          res => {
  //            if (res.status) {
  //              sessionStorage.setItem("udyamRegistrationNumber", u_num || '');
  //              sessionStorage.setItem("ownersMobileNumber", mob || '');
  //              alert("No matching record found from Udyam Portal. Register as new User");
  //              sessionStorage.setItem("isUdyamVerified", 'false');
  //              this.router.navigate(['/contactdetails'], { state: { formData: formDatavalue } });
  //            }
  //          }
  //        );
  //      }
  //    })
  //  } else {
  //    this.toastrService.error("Please provide both Udyam Registration Number and Mobile Number.");
  //  }
  //}   

  goToLogin() {
    this.router.navigate(['']);
  }
}
